import { render, staticRenderFns } from "./Percentage.vue?vue&type=template&id=e21198bc&scoped=true"
import script from "./Percentage.vue?vue&type=script&lang=js"
export * from "./Percentage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21198bc",
  null
  
)

export default component.exports